import en from "@/content/i18n/en.json";
import es from "@/content/i18n/es.json";
import fr from "@/content/i18n/fr.json";
import de from "@/content/i18n/de.json";
import ar from "@/content/i18n/ar.json";
import it from "@/content/i18n/it.json";
import pt from "@/content/i18n/pt.json";
import { defaultLocale, type SupportedLocale } from "@/lib/i18n";
import { normalizeBrandText } from "@/config/brands";

type Messages = Record<string, any>;

const messages: Record<string, Messages> & Record<SupportedLocale, Messages> = {
  en: en as Messages,
  es: es as Messages,
  fr: fr as Messages,
  de: de as Messages,
  ar: ar as Messages,
  it: it as Messages,
  pt: pt as Messages,
};

const getByPath = (obj: Messages, path: string): string | undefined => {
  return path.split(".").reduce((acc: any, key) => {
    if (acc && typeof acc === "object" && key in acc) return acc[key];
    return undefined;
  }, obj);
};

export const getMessage = (locale: SupportedLocale, key: string, fallback?: string) => {
  const localeValue = getByPath(messages[locale] ?? {}, key);
  if (typeof localeValue === "string" && localeValue.length > 0) return normalizeBrandText(localeValue) ?? localeValue;
  const defaultValue = getByPath(messages[defaultLocale] ?? {}, key);
  if (typeof defaultValue === "string" && defaultValue.length > 0) return normalizeBrandText(defaultValue) ?? defaultValue;
  const fb = fallback ?? key;
  return normalizeBrandText(fb) ?? fb;
};

export const getLocaleMessages = (locale: SupportedLocale) => messages[locale] ?? messages[defaultLocale];
